import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Heading,
  HStack,
  Icon,
} from '@chakra-ui/react';
import { useState } from 'react';
import { MdOutlineInventory2 } from 'react-icons/md';
import { toast } from 'react-toastify';
import { exportInstallationProducts } from 'services/productsExport';
import { useAppTabContext } from '../../AppContext';
import {
  buildProductsCsvRows,
  serializeProductsCsv,
} from './helpers/buildProductsCsv';
import { downloadCsv } from './helpers/downloadCsv';

const ProductsExport = () => {
  const { app } = useAppTabContext();
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = () => {
    setIsExporting(true);

    exportInstallationProducts(app.idi)
      .then((response) => {
        const { products, categories } = response.data;
        const rows = buildProductsCsvRows(products, categories);
        const csv = serializeProductsCsv(rows);
        downloadCsv(csv);
        toast.success('Produtos exportados com sucesso');
      })
      .catch(() => toast.error('Falha ao exportar produtos'))
      .finally(() => setIsExporting(false));
  };

  return (
    <Card>
      <CardHeader>
        <HStack>
          <Icon as={MdOutlineInventory2} />
          <Heading size="sm">Produtos</Heading>
        </HStack>
      </CardHeader>

      <CardBody>
        <Button
          variant="filled"
          size="sm"
          py="1.5rem"
          isLoading={isExporting}
          isDisabled={isExporting}
          onClick={handleExport}
        >
          Exportar produtos
        </Button>
      </CardBody>
    </Card>
  );
};

export default ProductsExport;
